<template>
  <div class="profiles-list">
    <ak-table class="mb" :data="data">
      <template #default="{ row }">
        <ak-table-column label="Profile">
          {{ row.name }}
        </ak-table-column>
        <ak-table-column label="Location">
          {{ row.location }}
        </ak-table-column>
        <ak-table-column label="">
          <ak-pack spacing="normal" class="flex--justify-end">
            <ak-pack-item>
              <ak-tooltip>
                <template #trigger>
                  <ak-button
                    class="profiles-list__action"
                    color="white"
                    size="small"
                    circle
                    @click="updateProfile(row._id)"
                  >
                    <ak-icon type="edit" color="grey-light" />
                  </ak-button>
                </template>
                Edit profile
              </ak-tooltip>
            </ak-pack-item>
            <ak-pack-item>
              <ak-tooltip>
                <template #trigger>
                  <ak-button
                    class="profiles-list__action"
                    color="white"
                    size="small"
                    circle
                    @click="deleteProfile(row)"
                  >
                    <ak-icon type="trash" color="danger" />
                  </ak-button>
                </template>
                Delete profile
              </ak-tooltip>
            </ak-pack-item>
          </ak-pack>
        </ak-table-column>
      </template>
    </ak-table>
    <div class="profiles-list__footer-actions">
      <ak-button @click="createProfile()">Add Profile</ak-button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPProfilesList',
  components: {
    [Button.name]: Button,
  },
  props: {
    data: {
      required: true,
      type: Array,
    },
  },
  emits: ['onCreateProfile', 'onUpdateProfile', 'onDeleteProfile'],
  setup(props, { emit }) {
    const columns = [
      {
        field: 'name',
        label: 'Profile',
      },
      {
        field: 'location',
        label: 'Location',
      },
    ]

    /**
     * Create a new profile
     */
    const createProfile = (type) => {
      emit('onCreateProfile', { type })
    }

    /**
     * Update an existing profile
     * @param {String} id
     */
    const updateProfile = (id) => {
      emit('onUpdateProfile', { id })
    }

    /**
     * Delete an existing profile
     * @param {Object} profile
     */
    const deleteProfile = (profile) => {
      emit('onDeleteProfile', profile)
    }

    return {
      createProfile,
      updateProfile,
      deleteProfile,
      columns,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@akerolabs/akero-vue/src/scss/_settings.scss';

.profiles-list {
  & > *:where(:not(:last-child)) {
    margin-bottom: $spacing-small;
  }

  &__action,
  &__edit-profile {
    cursor: pointer;
  }
}
</style>
